import classNames from 'classnames';
import React, { FC } from 'react';


import styles from './connected-account.less';
import { ConnectedBankAccount } from 'src/invoice/types/types';

interface ConnectedAccountProps {
    account: ConnectedBankAccount;

}

export const ConnectedAccount: FC<ConnectedAccountProps> = ({
    account: {
        bankIcon,
        bankName,
        accountName,
        accountMask,
        selected
    },
}) => (
    <div style={{ borderColor: selected ? '#0265DC' : undefined }} className={classNames('connected-account-container', styles.connectedAccountContainer)}>
        <img className={classNames('connected-account-logo', styles.connectedAccountLogo)} src={bankIcon || 'assets/images/browser-firefox.png'} alt={bankName} />
        <div className={classNames('connected-account-text', styles.connectedAccountText)}>
            {bankName}{' '}{accountName} •••• {accountMask}
        </div>
        {selected && (
            <div className={styles.connectedAccountChipHolder}>
                <div className={classNames('connected-account-chip-container', styles.connectedAccountChipContainer)}>
                    <div className={classNames('connected-account-chip', styles.connectedAccountChip)}>
                        Selected
                    </div>
                </div>
            </div>)}
    </div>
);